<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-alibl`]" width="1em" height="1em" v-bind="$attrs"><path d="M1.07166 4V12L4.53599 10V6L1.07166 4Z" :fill="useCurrentColor ? 'currentColor' : '#0423DB'"/><path d="M4.53601 6V10L8.00001 8L4.53601 6Z" :fill="useCurrentColor ? 'currentColor' : '#1C54E4'"/><path d="M8.00001 8.00038L4.53601 6.00038L11.4627 1.99805L14.9283 4.00038L8.00001 8.00038Z" :fill="useCurrentColor ? 'currentColor' : '#AB9BFF'"/><path d="M4.53599 6L1.07166 4L7.99999 0L11.4627 1.99767L4.53599 6Z" :fill="useCurrentColor ? 'currentColor' : '#7347FF'"/><path d="M14.9283 12L8.00001 16L4.53601 14L11.464 10L14.9283 12Z" :fill="useCurrentColor ? 'currentColor' : '#00CFCA'"/><path d="M11.464 10L14.9283 8V12L11.464 10ZM4.53599 14L1.07166 12L7.99999 8L11.464 10L4.53599 14Z" :fill="useCurrentColor ? 'currentColor' : '#00EBD2'"/></svg>
</template>
<script>

export default {
  name: 'IconColorAlibl',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
